import { useGetHttp } from "../../http.hook";

export enum DMSCampaignStatus{
	Proposal = "Proposal",
	Approved = "Approved",
	Active = "Active",
	Complete = "Complete",
	Cancel = "Cancel",
	OnHold = "On Hold"
}

export default interface IDMSCampaign {
	campaignId: string;
	name: string;
	campaignLead: string;
	campaignStatus: DMSCampaignStatus;
	approvedAt: string;
}

interface IResponse {
	campaigns: Array<IDMSCampaign>;
}

export function useGetDMSCampaignsListAdminHttp() {
	return useGetHttp<IResponse>({
		path: "/admin/dms/campaigns",
	});
}
